<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "form_fields_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-with-0-margin">
        <sp-form-element-settings
            [elementForm]="itemForm"
            [elements]="elements"
            [addressBookVariablesList]="addressBookVariablesList"
            [crmContactsVariablesList]="crmContactsVariablesList"
            [crmDealsVariablesList]="crmDealsVariablesList"
            [crmPipelinesList]="crmPipelinesList"
            [isMainField]="isMainField"
            [isAddressBookListDisabled]="isAddressBookListDisabled"
            [baseHref]="baseHref"
            [isShowProtectedList]="false"
            [deviceMode]="selectedDeviceMode$ | async"
        ></sp-form-element-settings>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
